/**
 * CX Card Grid (mobile scroll arrows): delegated click for banner grid arrows. Self-contained.
 */
(function () {
  let _reducedMotion = false;
  let _reducedMotionBound = false;
  function ensureReducedMotionCache() {
    if (_reducedMotionBound) return;
    _reducedMotionBound = true;
    if (typeof window === 'undefined' || typeof window.matchMedia !== 'function') return;
    const mql = window.matchMedia('(prefers-reduced-motion: reduce)');
    _reducedMotion = !!mql.matches;
    const onChange = (e) => { _reducedMotion = !!e.matches; };
    if (typeof mql.addEventListener === 'function') mql.addEventListener('change', onChange);
    else if (typeof mql.addListener === 'function') mql.addListener(onChange);
  }
  function prefersReducedMotion() { return _reducedMotion; }

  const CX_CARD_GRID_ARROW_SELECTOR = '[data-banner-grid-arrow]';
  let CX_CARD_GRID_DELEGATED_BOUND = false;

  function bindCxCardGridDelegated() {
    if (CX_CARD_GRID_DELEGATED_BOUND) return;
    CX_CARD_GRID_DELEGATED_BOUND = true;
    if (window.Shopify?.designMode) return;

    ensureReducedMotionCache();

    document.addEventListener('click', (event) => {
      const target = event.target instanceof Element ? event.target : null;
      const arrow = target?.closest?.(CX_CARD_GRID_ARROW_SELECTOR);
      if (!(arrow instanceof HTMLElement)) return;

      const direction = arrow.dataset.direction;
      const targetId = arrow.dataset.target;
      if (!targetId) return;

      const viewport = document.getElementById(targetId);
      if (!(viewport instanceof HTMLElement)) return;

      const firstCard = viewport.querySelector('.banner-grid__item');
      if (!(firstCard instanceof HTMLElement)) return;

      const grid = viewport.querySelector('.banner-grid__grid');
      const gap = grid ? Number.parseInt(getComputedStyle(grid).gap, 10) || 0 : 0;
      const scrollAmount = firstCard.offsetWidth + gap;

      const maxScrollLeft = viewport.scrollWidth - viewport.clientWidth;
      const atStart = viewport.scrollLeft <= 2;
      const atEnd = viewport.scrollLeft >= maxScrollLeft - 2;

      const behavior = prefersReducedMotion() ? 'auto' : 'smooth';

      if (direction === 'left') {
        if (atStart) {
          viewport.scrollTo({ left: maxScrollLeft, behavior });
          return;
        }

        viewport.scrollBy({ left: -scrollAmount, behavior });
        return;
      }

      if (atEnd) {
        viewport.scrollTo({ left: 0, behavior });
        return;
      }

      viewport.scrollBy({ left: scrollAmount, behavior });
    });
  }

  /** @type {any} */ (window)['CX'] = /** @type {any} */ (window)['CX'] || {};
  /** @type {any} */ (window)['CX'].bindCardGridMobileArrows = bindCxCardGridDelegated;

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', bindCxCardGridDelegated, { once: true });
  } else {
    setTimeout(bindCxCardGridDelegated, 0);
  }
  document.addEventListener('shopify:section:load', () => bindCxCardGridDelegated());
})();
